import { Box, LoaderNew, ModBox, TextNew } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import * as React from 'react'
import { FC, useEffect, useRef, useState } from 'react'
import { InteractionManager } from 'react-native'
import { AepsTextInput } from '../AepsTextInput'
import styles from './style'
import { TextInputProps } from './types'

//COUNTDOWN TIMER VALUE
const COUNTDOWN = 30
const COUNTDOWN_TIMER = 0
const SECOND = 1000
const MAX_INPUT = 6
const MAX_RETRY = 3

const OtpTextInputWithMaxRetry: FC<TextInputProps> = (props: TextInputProps) => {
  const hide = props?.hide ?? false
  //Optimise is touched by using ref
  let isTouched = React.useRef(false)
  //IS FOCUSED HOOK
  const isFocused = useIsFocused()
  //TEXT INPUT FOCUS
  const OtpInput = useRef<TextInputProps>(null)

  //VALUE OF TEXTFIELD
  const [otpValue, setValue] = useState(props?.value ?? '')
  //SETTING VALUE WHEN TEXT INPUT IS FOCUSED
  const [focused, setFocused] = useState(false)
  const [countDownTimer, setCountDownTimer] = useState(COUNTDOWN)

  //ERROR CONDITION
  const isError = otpValue?.length < MAX_INPUT && !focused && isTouched?.current
  //CONDITION TO SHOW THE TIMER COMPONENT
  const showTimeTickling = countDownTimer > COUNTDOWN_TIMER && countDownTimer <= COUNTDOWN

  const onResendOtpButtonPress = props?.onResendOtpButtonPress
  const isResendOtpLoading = props?.isResendOtpLoading

  //THIS WILL START THE TIMER.
  useEffect(() => {
    let timer: any
    if (countDownTimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDownTimer - 1), SECOND)
    }
    //Clear all the subscriptions and listeners on unmount
    return () => clearInterval(timer)
  }, [countDownTimer])

  //AUTO FOCUS THE TEXT INPUT
  useEffect(() => {
    // Must run after animations for keyboard to automatically open
    if (isFocused) {
      InteractionManager.runAfterInteractions(() => {
        if (OtpInput?.current) {
          OtpInput?.current?.focus()
        }
      })
    }
  }, [isFocused])

  //SETTING FOCUSED TO TRUE WHEN USER CLICKS ON TEXT INPUT
  const onFocus = () => {
    isTouched.current = true
    setFocused(true)
  }

  //SETTING FOCUSED TO FALSE WHEN USER CLICKS ON TEXT INPUT
  const onBlur = () => {
    setFocused(false)
  }

  const onResendOtp = () => {
    if (props.sendOtpRetryCount <= MAX_RETRY) {
      onResendOtpButtonPress && onResendOtpButtonPress()
    }
    setCountDownTimer(COUNTDOWN)
  }

  //WHEN TEXT INPUT TEXT CHANGES
  const handleChange = (text: string) => {
    setValue(text)
    if (props.onChangeText) {
      props.onChangeText(text)
    }
    if (props.setFieldValue && props.fieldName) {
      props.setFieldValue(props.fieldName, text)
    }
  }

  //RIGHT COMPONENT OF TEXT INPUT
  const ResendComponent = () => {
    if (isResendOtpLoading) {
      return <LoaderNew type={'small'} color={'PRIMARY_STORNG'} />
    } else {
      return showTimeTickling ? (
        <TextNew {...styles.timerText} title={`00:${countDownTimer}`} />
      ) : (
        <ModBox
          show={props.sendOtpRetryCount < MAX_RETRY}
          onPress={onResendOtp}
          underlayColor={'LIGHTEST_GREY'}
          flexDirection="row">
          <TextNew {...styles.resendText} title="RESEND" />
          <TextNew {...styles.countText} title={` (${MAX_RETRY - props.sendOtpRetryCount})`} />
        </ModBox>
      )
    }
  }

  if (hide) {
    return null
  }

  return (
    <Box {...styles.container} onPress={() => OtpInput?.current?.focus()} underlayColor="TRANSPARENT">
      <Box {...styles.subContainer}>
        <Box {...styles.wrap} underlayColor="TRANSPARENT">
          <Box {...styles.inputBox}>
            <AepsTextInput
              value={otpValue}
              onChangeText={handleChange}
              placeholder={'6 Digit OTP'}
              secureTextEntry
              rightComponent={<ResendComponent />}
              keyboardType="numeric"
              maxLength={6}
              returnKeyType={otpValue?.length > 5 ? 'done' : 'next'}
            />
          </Box>
        </Box>
      </Box>
      <Box {...styles.errorView}>
        {isError && (
          <TextNew {...styles.errorText} numberOfLines={1}>
            {props.error ?? 'Invalid Otp'}
          </TextNew>
        )}
      </Box>
    </Box>
  )
}

export { OtpTextInputWithMaxRetry }
